import React from "react";

function EmptyCart() {
  return (
    <div className="cart_content">
      <div className="cart__content-product">Your Cart is Empty</div>
    </div>
  );
}

export default EmptyCart;
